var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(" Ovo je nas hello world ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }